import { AboutFeatureId } from "../enums";
import type { AboutFeature } from "../types";

export const ABOUT_FEATURES: AboutFeature[] = [
  {
    id: AboutFeatureId.INVENTORY,
    titleKey: "about-page-feature-inventory",
    titleFallback: "Manage products, categories, and stock across locations"
  },
  {
    id: AboutFeatureId.ORDERS,
    titleKey: "about-page-feature-orders",
    titleFallback: "Record sales and purchases with clear records"
  },
  {
    id: AboutFeatureId.STORES,
    titleKey: "about-page-feature-stores",
    titleFallback:
      "Organize multiple stores with role-based access for employees"
  },
  {
    id: AboutFeatureId.INSIGHTS,
    titleKey: "about-page-feature-insights",
    titleFallback: "See sales and stock at a glance"
  },
  {
    id: AboutFeatureId.APPS,
    titleKey: "about-page-feature-apps",
    titleFallback:
      "Use the website or install computer and phone apps with the same account"
  }
];
